// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteAccountGetWorkflowsDefaultResponse {
    static getAttributeTypeMap() {
        return SiteAccountGetWorkflowsDefaultResponse.attributeTypeMap;
    }
}
SiteAccountGetWorkflowsDefaultResponse.discriminator = undefined;
SiteAccountGetWorkflowsDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<WorkflowModel>"
    }
];
//# sourceMappingURL=siteAccountGetWorkflowsDefaultResponse.js.map